import axios from "axios";

export default class StatisticService {
  static getStatisticReport(payload) {
    return axios.post("statistic", payload);
  }

  static statisticReport(startDate, endDate, type, payload) {
    var url = `statistic/report?start_date=${startDate}&&end_date=${endDate}&&type=${type}&&filters=${payload}`;
    return axios.get(url,{
      responseType: 'blob',
    });
  }
}
